import ga4 from 'react-ga4'
const TRACKING_ID = 'G-K2LQLHV2TF'

export const init = () => ga4.initialize(TRACKING_ID)

export const sendEvent = (name, props) => ga4.event(name, {
    ...props,
})

export const sendPageview = (path) => {
    ga4.send({
        hitType: 'pageview',
        page: path,
    })
}

export const setUser = (user) => {
    ga4.set({ userId: user.exidentifier });
    ga4.gtag("set", "user_properties", {
        ...user
    });
}

export const clearUser = () => {
    ga4.set({ userId: null });
    ga4.gtag('set', 'user_properties', null); // Passing null clears the user properties
    // ga4.gtag('event', 'session_end', {
    //     // Include any additional event parameters if needed
    // });
};
